import {
  FDContentContainer,
  FDStack, FDTextButton,
} from '@facet-wealth/design';
import React from 'react';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import useMobileLayout from 'Hooks/useMobileLayout';
import Footer from 'Components/ClientApp/Desktop/Footer';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { Richtext } from 'src/Packages/FacetDesign/Components/Richtext';
import MetaControlField from 'src/Components/UI/Meta/MetaForm/Components/MetaControlField';
import { TaxHomeHeading } from './Heading/TaxHome-Heading';
import { TaxHomeCompare } from './Compare/TaxHome-Compare';
import { TaxHomeHowItWorks } from './HowItWorks/TaxHome-HowItWorks';

const useStyles = buildUseStyles('ReferralPage', () => ({
  footer: {
    paddingTop: '88px',
    position: 'sticky',
    transform: 'initial',
    bottom: 'unset',
  },
  wrapText: {
    wordWrap: 'break-word',
  },
}));

export const Layout = () => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();
  const classes = useStyles();
  const { loadPageContentLink } = usePageContentContext();

  useBoneBackgroundColor();

  return (
    <>
      <FDContentContainer maxWidth="lg">
        {
          resource.withRelationship(fr.relationships.taxFilingPartnerPage.name, (rel) => {
            return <FDTextButton onClick={() => loadPageContentLink(rel.link('related'))} label={'File taxes'} />;
          }, () => null)
        }
        <FDStack direction="column" spacing={isMobile ? 4 : 11} alignItems="center" paddingY={3}>
          <FDStack direction="column" spacing={isMobile ? 3 : 6}>
            <TaxHomeHeading />
            <MetaControlField attr={'description'} />
          </FDStack>
          <TaxHomeCompare />
          <TaxHomeHowItWorks />
          <MetaControlField attr={'frequentlyAskedQuestions'} />
          <Richtext richtext color="textDisabled" size="sm" value={resource.attr('taxHomeDisclosure')} />
        </FDStack>
      </FDContentContainer>
      {!isMobile && <Footer className={classes.footer} />}
    </>
  );
};
